import InformationScreen from "./InformationScreen"
export default InformationScreen